import React from 'react';
import './RecognizedSection.css';
import medalIcon from '../../assets/icons/medal.svg';
import startupIndiaImg from '../../assets/images/recog-incubated/startup-india.png';
import startupOdishaImg from '../../assets/images/recog-incubated/startup-odisha.png';
import wadhwaniImg from '../../assets/images/recog-incubated/wadhwani-foundation.png';
import iitBhuImg from '../../assets/images/recog-incubated/iit-bhu.png';

const RecognizedSection = () => {
  return (
    <section className="recognized-section">
      <div className="recognized-header">
        <img
          src={medalIcon}
          alt="Recognition Medal"
          className="recognized-icon"
        />
        <h2 className="recognized-heading">
          Recognized & <span className="highlight-text">Incubated By</span>
        </h2>
        <div className="underline2"></div>
      </div>

      <div className="recognized-logos-container">
        <div className="recognized-logo-item">
          <img src={startupIndiaImg} alt="DPIIT Startup India" />
        </div>
        <div className="recognized-logo-item">
          <img src={startupOdishaImg} alt="Startup Odisha" />
        </div>
        <div className="recognized-logo-item">
          <img src={wadhwaniImg} alt="Wadhwani Foundation" />
        </div>
        <div className="recognized-logo-item">
          <img src={iitBhuImg} alt="IIT Bhubaneswar" />
        </div>
      </div>
    </section>
  );
};

export default RecognizedSection;
